const binding = { modules: {}, dataActions: {} };

    (binding.modules['who-we-are-banner'] = {
        c: () => require('partner/modules/who-we-are-banner/who-we-are-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'who-we-are-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/who-we-are-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|who-we-are-banner|who-we-are-banner'] = {
                c: () => require('partner/modules/who-we-are-banner/who-we-are-banner.view.tsx'),
                cn: '__local__-__local__-who-we-are-banner'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };